/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as LoginImport } from './routes/login'
import { Route as AppImport } from './routes/app'
import { Route as IndexImport } from './routes/index'

// Create Virtual Routes

const AppSubscriptionsIndexLazyImport = createFileRoute('/app/subscriptions/')()
const AppSearchIndexLazyImport = createFileRoute('/app/search/')()

// Create/Update Routes

const LoginRoute = LoginImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRoute,
} as any)

const AppRoute = AppImport.update({
  id: '/app',
  path: '/app',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const AppSubscriptionsIndexLazyRoute = AppSubscriptionsIndexLazyImport.update({
  id: '/subscriptions/',
  path: '/subscriptions/',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/app/subscriptions/index.lazy').then((d) => d.Route),
)

const AppSearchIndexLazyRoute = AppSearchIndexLazyImport.update({
  id: '/search/',
  path: '/search/',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/app/search/index.lazy').then((d) => d.Route),
)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/app': {
      id: '/app'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof AppImport
      parentRoute: typeof rootRoute
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginImport
      parentRoute: typeof rootRoute
    }
    '/app/search/': {
      id: '/app/search/'
      path: '/search'
      fullPath: '/app/search'
      preLoaderRoute: typeof AppSearchIndexLazyImport
      parentRoute: typeof AppImport
    }
    '/app/subscriptions/': {
      id: '/app/subscriptions/'
      path: '/subscriptions'
      fullPath: '/app/subscriptions'
      preLoaderRoute: typeof AppSubscriptionsIndexLazyImport
      parentRoute: typeof AppImport
    }
  }
}

// Create and export the route tree

interface AppRouteChildren {
  AppSearchIndexLazyRoute: typeof AppSearchIndexLazyRoute
  AppSubscriptionsIndexLazyRoute: typeof AppSubscriptionsIndexLazyRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppSearchIndexLazyRoute: AppSearchIndexLazyRoute,
  AppSubscriptionsIndexLazyRoute: AppSubscriptionsIndexLazyRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/app/search': typeof AppSearchIndexLazyRoute
  '/app/subscriptions': typeof AppSubscriptionsIndexLazyRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/app/search': typeof AppSearchIndexLazyRoute
  '/app/subscriptions': typeof AppSubscriptionsIndexLazyRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/app/search/': typeof AppSearchIndexLazyRoute
  '/app/subscriptions/': typeof AppSubscriptionsIndexLazyRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/app' | '/login' | '/app/search' | '/app/subscriptions'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/app' | '/login' | '/app/search' | '/app/subscriptions'
  id:
    | '__root__'
    | '/'
    | '/app'
    | '/login'
    | '/app/search/'
    | '/app/subscriptions/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/app",
        "/login"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/app": {
      "filePath": "app.tsx",
      "children": [
        "/app/search/",
        "/app/subscriptions/"
      ]
    },
    "/login": {
      "filePath": "login.tsx"
    },
    "/app/search/": {
      "filePath": "app/search/index.lazy.tsx",
      "parent": "/app"
    },
    "/app/subscriptions/": {
      "filePath": "app/subscriptions/index.lazy.tsx",
      "parent": "/app"
    }
  }
}
ROUTE_MANIFEST_END */
